{
  "fr": {
    "tools": {
      "descriptions": {
        "verseGuide": "Guide de voyage complet avec cartes système détaillées, points d'intérêt et routes d'exploration dans l'univers Star Citizen",
        "starCitizenTools": "Wiki communautaire avec documentation extensive sur les vaisseaux, armes, lieux, mécaniques de jeu et lore",
        "verseintel": "Graphe de connaissances Star Citizen qui relie déclarations des développeurs, notes de patch, articles, publications Spectrum et vidéos en une seule archive consultable et référencée",
        "starship42": "Visualiseur 3D interactif de vaisseaux avec modèles détaillés extérieurs et intérieurs, placement de composants et comparaisons de taille",
        "erkul": "Calculatrice DPS avancée et optimiseur de configuration de vaisseaux avec statistiques détaillées d'armes et comparaisons de composants",
        "starjump": "Outil de visualisation 2D de flottes pour créer de beaux layouts de vaisseaux et graphiques d'organisation de flottes",
        "itemFinder": "Base de données complète de localisation d'objets et d'équipements avec suivi de disponibilité en temps réel dans l'univers",
        "starHangar": "Marché de confiance pour les packages de vaisseaux Star Citizen avec trading sécurisé et suivi des prix",
        "shinytracker": "Suivi de progression personnel pour missions, réputation, succès et objectifs d'exploration avec statistiques détaillées",
        "uexCorp": "Plateforme de trading de matières premières en temps réel avec suivi des prix, optimisation des routes commerciales et outils d'analyse de marché",
        "cargoGridViewer": "Visualiseur 3D de grille de cargaison montrant les dimensions de soute et l'ajustement des conteneurs pour tous les vaisseaux",
        "scmdb": "Parcourez les missions, récompenses, chemins de réputation, ressources minières et plus pour Star Citizen",
        "regolith": "Outil minier Star Citizen avec scan de roches, calculs de raffinage et comparaisons de têtes de minage",
        "spviewer": "Ship performance analysis tool with detailed flight characteristics, speed comparisons, and maneuverability data",
        "citizenId": "Service de vérification d'identité et d'authentification OAuth Star Citizen pour les outils communautaires",
        "hauler": "Planificateur de routes de transport de fret et calculateur de profits pour les commerçants Star Citizen"
      },
      "categories": {
        "trading": "Commerce et Économie",
        "loadouts": "Équipement et Combat",
        "mining": "Minage",
        "missions": "Missions et Base de Données",
        "fleet": "Gestion de Flotte"
      },
      "discontinued": "Ce projet a été abandonné.",
      "discontinuedHeading": "Projets abandonnés"
    }
  }
}
